module.exports = __webpack_public_path__ + "img/cq3d-title-icon.91e57a88.png";